export function isNull(value) {
    return value === null;
}
export function assertIsNull(value) {
    if (isNotNull(value)) {
        throw new TypeError(`Value is not null.`);
    }
}
export function isNotNull(value) {
    return value !== null;
}
export function assertIsNotNull(value) {
    if (isNull(value)) {
        throw new TypeError(`Value is null.`);
    }
}
//# sourceMappingURL=null.js.map